export default "__VITE_ASSET__7f4960f0__"